import type { StageId } from '@/layout/types';

export interface StageMeta {
  id: StageId;
  /** Drawer tab label. */
  short: string;
  title: string;
  intro: string;
}

export const STAGES: StageMeta[] = [
  {
    id: 'source',
    short: 'Population',
    title: 'Total population',
    intro:
      'The outreach denominator is the sum of source populations minus exclusions. Add, edit, or remove either group and the whole pathway re-scales.',
  },
  {
    id: 'reach',
    short: 'Engagement',
    title: 'Engaged (reached)',
    intro:
      'Live or interactive contact for screening. This rate is not typed in — it is the blend of the subpopulation conversion rates in column 1.',
  },
  {
    id: 'screen',
    short: 'Screening',
    title: 'Screened',
    intro:
      'A completed PHQ-2 is the screening event. Everyone screened then sits under 10 on the PHQ-9 or at 10 and above — only the second group owes a follow-up.',
  },
  {
    id: 'chase',
    short: 'Follow-up',
    title: 'Follow-up required',
    intro:
      'The chase pool splits into cohorts by how much of a relationship already exists. Each carries its own reach and completion rate; columns 5 and 6 are their blend.',
  },
];

export const STAGE_BY_ID = new Map(STAGES.map((s) => [s.id, s]));
